webpackJsonp([80841616431910],{

/***/ 1148:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(8);
	
	var _navManager = __webpack_require__(22);
	
	var _newsAndEventsManager = __webpack_require__(219);
	
	var _cards = __webpack_require__(17);
	
	var _newsCard = __webpack_require__(120);
	
	var _commonPageHeader = __webpack_require__(244);
	
	var _commonFilterBar = __webpack_require__(373);
	
	var _commonSidebar = __webpack_require__(245);
	
	var _pagination = __webpack_require__(78);
	
	var _link = __webpack_require__(9);
	
	var _newsAndEvents = __webpack_require__(264);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NewsPage = function (_React$PureComponent) {
		_inherits(NewsPage, _React$PureComponent);
	
		function NewsPage() {
			var _temp, _this, _ret;
	
			_classCallCheck(this, NewsPage);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.state = {
				search: ''
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		NewsPage.prototype.render = function render() {
			var _this2 = this;
	
			var _props$pathContext = this.props.pathContext,
			    pageNumber = _props$pathContext.pageNumber,
			    totalPages = _props$pathContext.totalPages;
			var _props$data = this.props.data,
			    page = _props$data.page,
			    news = _props$data.news,
			    types = _props$data.types;
			var search = this.state.search;
	
			var pageSettings = page.edges[0].node;
			var newsTypes = (types && types.edges || []).map(function (_ref) {
				var node = _ref.node;
				return node.title;
			});
	
			return _react2.default.createElement(
				_react2.default.Fragment,
				null,
				_react2.default.createElement(
					_reactHelmet.Helmet,
					{ title: 'News' },
					_react2.default.createElement('meta', { property: 'og:type', content: 'website' }),
					_react2.default.createElement('meta', { property: 'og:title', content: 'InsideOut - News' })
				),
				_react2.default.createElement(_commonPageHeader.CommonPageHeader, { activeItem: 'news' }),
				_react2.default.createElement(_commonFilterBar.CommonFilterBar, {
					placeholderText: 'Search news',
					onChange: function onChange(e) {
						return _this2.setState({ search: e.target.value });
					},
					value: search,
					onSubmit: function onSubmit(e) {
						e.preventDefault();
						(0, _link.navigateTo)('/news/search-results?query=' + encodeURIComponent(search));
					}
				}),
				_react2.default.createElement(
					'div',
					{ className: _newsAndEvents.tabPageWrapper },
					_react2.default.createElement(
						'div',
						{ className: _newsAndEvents.innerWrapperStyle },
						_react2.default.createElement(
							'div',
							{ className: _newsAndEvents.leftStyle },
							news && _react2.default.createElement(
								'section',
								{ className: _newsAndEvents.sectionStyle },
								_react2.default.createElement(
									'header',
									null,
									_react2.default.createElement(
										'h1',
										{ className: _newsAndEvents.subTitleStyle },
										'Latest News'
									)
								),
								_react2.default.createElement(
									_cards.Cards,
									null,
									news.edges.map(function (_ref2, index) {
										var node = _ref2.node;
										return _react2.default.createElement(_newsCard.NewsCard, {
											key: index,
											to: (0, _navManager.idToLink)(node.id),
											title: node.title,
											body: node.extract,
											date: node.date,
											background: node.fields && node.fields.thumbnail_image.childImageSharp.resize.src
										});
									})
								)
							),
							totalPages !== 1 && _react2.default.createElement(_pagination.Pagination, {
								initialPage: pageNumber,
								pageCount: totalPages,
								onPageChange: function onPageChange(page) {
									(0, _link.navigateTo)((0, _newsAndEventsManager.linkWithFilter)({ base: ['news'], page: page }));
								}
							})
						),
						_react2.default.createElement(
							'div',
							{ className: _newsAndEvents.rightStyle },
							_react2.default.createElement(_commonSidebar.CommonSidebar, null)
						)
					)
				)
			);
		};
	
		return NewsPage;
	}(_react2.default.PureComponent);
	
	NewsPage.propTypes = {
		pathContext: _propTypes2.default.shape({
			pageNumber: _propTypes2.default.number.isRequired,
			totalPages: _propTypes2.default.number.isRequired
		}).isRequired,
	
		data: _propTypes2.default.shape({
			page: _propTypes2.default.shape({
				edges: _propTypes2.default.arrayOf(_propTypes2.default.shape({
					node: _propTypes2.default.shape({
						purple_heading: _propTypes2.default.string.isRequired,
						orange_heading: _propTypes2.default.string.isRequired,
						orange_body: _propTypes2.default.string.isRequired,
						orange_link_text: _propTypes2.default.string.isRequired,
						orange_link_url: _propTypes2.default.string.isRequired
					}).isRequired
				})).isRequired
			}).isRequired,
	
			types: _propTypes2.default.shape({
				edges: _propTypes2.default.arrayOf(_propTypes2.default.shape({
					node: _propTypes2.default.shape({
						title: _propTypes2.default.string.isRequired
					}).isRequired
				})).isRequired
			}),
	
			news: _propTypes2.default.shape({
				edges: _propTypes2.default.arrayOf(_propTypes2.default.shape({
					node: _propTypes2.default.shape({
						id: _propTypes2.default.string.isRequired,
						title: _propTypes2.default.string.isRequired,
						date: _propTypes2.default.string.isRequired,
						extract: _propTypes2.default.string.isRequired,
						fields: _propTypes2.default.shape({
							thumbnail_image: _propTypes2.default.shape({
								childImageSharp: _propTypes2.default.shape({
									resize: _propTypes2.default.shape({
										src: _propTypes2.default.string.isRequired
									}).isRequired
								}).isRequired
							}).isRequired
						})
					}).isRequired
				})).isRequired
			}).isRequired
		}).isRequired
	};
	exports.default = NewsPage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-news-and-events-news-index-js-122dbbc1ea1ade29f432.js